'use strict';

import './postLeadSurvey.scss';
import template from './postLeadSurvey.template.html';
import controller from './postLeadSurvey.controller.js';

const component = {
    bindings: {
        vdpApiKey: '@',
        apigeeHost: '@',
        shadowSettingsProxy: '@'
    },
    controller,
    template
};

export default component;
